import {CartItem} from '../CartItem'
import {isTouching} from '../is'
import {replaceInString} from '../replaceInString'
import {VariantDict} from '../VariantDict'
import {isSwatchOption, notMaster} from '../filters'

const $window = $(window)

export function initOrderForm() {
	$('.order-form').once('initOrderForm').each(function () {
		const $form = $(this)
		const $variants = $form.find('.order-form__variants')
		const $options = $form.find('.option')
		const $atc = $form.find('.order-form__atc')

		const title = $form.data('productTitle')
		const fallbackImage = $form.data('fallbackImage')
		const dict = new VariantDict($form.data('variantInfo'))

		$options.on('change', function (e) {
			const $option = $(e.currentTarget)
			if ($option.length) {
				update($option.data('optionIsSwatch'))
			} else {
				update(false)
			}
		})
		update(true)

		$form.find('.js-not-yet').removeClass('js-not-yet')
		$form.find('.js-fallback').removeClass('js-fallback').addClass('js-not-needed')

		$atc.on('click', function (e) {
			e.preventDefault()
			e.stopPropagation()
			dict.ifVariantExists({}, variant => {
				const fullVariant = {
					product_title: title,
					...variant
				}

				if (!fullVariant.featured_image) {
					fullVariant.featured_image = {
						url: fallbackImage
					}
				}

				cart.addItem(new CartItem(fullVariant, 1))
				cart.update()

				const messageTemplate = $('body').data('quickAddToastSuccess')
				const message = replaceInString(messageTemplate, {title})
				$window.trigger('quickAdd:itemAdded', {message})
			})
		})

		// private methods

		function update(isSwatchUpdate) {
			// Update VariantDict default key
			$options.each(function () {
				const $option = $(this)
				const idx = $option.data('optionIndex')
				const val = $option.find(':checked').val()
				dict.updateDefaultKey({[idx]: val})
			})

			// Update the disabled prop of all non-master inputs
			notMaster($options).each(function () {
				const $option = $(this)
				const idx = $option.data('optionIndex')
				$option.find('input').each(function () {
					const variant = dict.ifVariantExists({[idx]: $(this).val()}, ({available}) => {
						$(this).attr('disabled', !available)
					})
				})
			})

			// Select the first non-disabled value IF a disabled value is selected
			$options.each(function () {
				const $option = $(this)
				const $current = $option.find('input:checked')
				if ($current.is(':disabled')) {
					const $next = $option.find('input:not(:disabled)').first()
					if ($next.length) {
						$next.prop('checked', true)
						dict.updateDefaultKey({[$option.data('optionIndex')]: $next.val()})
					}
				}
			})

			// Update the `id` select input
			dict.ifVariantExists({}, variant => {
				$variants.val(variant.id)
			})

			// Update the swatch label
			isSwatchOption($options).each(function () {
				const $option = $(this)
				const $label = $option.find('.option__extra')
				if ($label.length) {
					$label.text($option.find('input:checked').val())
				}
			})

			// Click on swatch when mousing over
			isSwatchOption($options).each(function () {
				const $section = $(this)
				let resetTimeout
				let $currentValue = $section.find('.option-value input:checked').parent()
				$section.find('.option-value').once('mouseOverColor').on('mouseenter', function () {
					if (isTouching()) {
						return
					}

					clearTimeout(resetTimeout)
					const $value = $(this)
					$value.click()

					let isFullySelected = false
					$value.one('mouseleave', function () {
						$value.off('click', onClick)
						if (!isFullySelected) {
							clearTimeout(resetTimeout)
							resetTimeout = setTimeout(function () {
								$currentValue.click()
							}, 175)
						}
					})
					$value.one('click', onClick)

					function onClick(e) {
						isFullySelected = true
						$currentValue = $value
						e.preventDefault()
						e.stopPropagation()
					}
				})
			})

			// Update the ATC button!
			dict.ifVariantExists({}, ({available}) => {
				$atc.attr('disabled', !available)
				$atc.toggleClass('order-form__atc-primary', available)
				$atc.toggleClass('order-form__atc-secondary', !available)
				if (available) {
					$atc.find('.atc__label').html($form.data('productAddToCart'))
					$atc.find('.atc__icon').show()
				} else {
					$atc.find('.atc__label').html($form.data('productSoldOut'))
					$atc.find('.atc__icon').hide()
				}
			})

			// Let the world know about our new selection!
			dict.ifVariantExists({}, variant => {
				$(window).trigger('orderForm:variantSelected', {
					variant,
					isSwatchUpdate
				})
			})
		}
	})
}